<script setup lang="ts">

import { TaskType } from '@shared/config'
import { AppText } from '@shared/ui/typography'

import { useTasksKanbanStore } from '../../model/store'
import TaskAdditionalDetailsPlaceholder from './TaskAdditionalDetailsPlaceholder.vue'
import InfoAutoCanceledSubscription from '../additional-info/billing/InfoAutoCanceledSubscription.vue'
import InfoAutorenewFailed from '../additional-info/billing/InfoAutorenewFailed.vue'
import InfoCancelSubscription from '../additional-info/billing/InfoCancelSubscription.vue'
import InfoChargeback from '../additional-info/billing/InfoChargeback.vue'
import InfoDowngradeSubscription from '../additional-info/billing/InfoDowngradeSubscription.vue'
import InfoFailedPayment from '../additional-info/billing/InfoFailedPayment.vue'
import InfoRefundSubscription from '../additional-info/billing/InfoRefundSubscription.vue'
import InfoUpgradeSubscription from '../additional-info/billing/InfoUpgradeSubscription.vue'
import InfoHealthCheck from '../additional-info/success/InfoHealthCheck.vue'
import InfoSuccessBadFeedback from '../additional-info/success/InfoSuccessBadFeedback.vue'
import InfoCallbackRequest from '../additional-info/support/InfoCallbackRequest.vue'
import InfoChangeSchedule from '../additional-info/support/InfoChangeSchedule.vue'
import InfoChangeTutor from '../additional-info/support/InfoChangeTutor.vue'
import InfoCustomerRequest from '../additional-info/support/InfoCustomerRequest.vue'
import InfoFirstLessonCancellation from '../additional-info/support/InfoFirstLessonCancellation.vue'
import InfoFirstLessonCancellationTutor from '../additional-info/support/InfoFirstLessonCancellationTutor.vue'
import InfoInvoiceCreation from '../additional-info/support/InfoInvoiceCreation.vue'
import InfoManualActivation from '../additional-info/support/InfoManualActivation.vue'
import InfoPauseSubscription from '../additional-info/support/InfoPauseSubscription.vue'
import InfoResumeSubscription from '../additional-info/support/InfoResumeSubscription.vue'
import InfoSubstituteTutor from '../additional-info/support/InfoSubstituteTutor.vue'
import InfoSupportBadFeedback from '../additional-info/support/InfoSupportBadFeedback.vue'
import InfoTechnicalIssue from '../additional-info/support/InfoTechnicalIssue.vue'
import InfoCustomerType from '../additional-info/success/InfoCustomerType.vue'

defineOptions({
  name: 'TaskAdditionalDetails',
})

const tasksKanbanStore = useTasksKanbanStore()

</script>

<template>
  <div class="task-additional-details">
    <AppText
      name="body1-medium"
      color="slate-900"
    >
      Additional details
    </AppText>

    <template v-if="tasksKanbanStore.hasTaskType">
      <InfoCustomerType
        v-if="tasksKanbanStore.isTaskType(TaskType.Onboarding)"
      />
      <InfoAutorenewFailed
        v-if="tasksKanbanStore.isTaskType(TaskType.AutorenewFailed)"
      />
      <InfoCancelSubscription
        v-if="tasksKanbanStore.isTaskType(TaskType.CancelSubscription)"
      />
      <InfoChargeback
        v-if="tasksKanbanStore.isTaskType(TaskType.Chargeback)"
      />
      <InfoDowngradeSubscription
        v-if="tasksKanbanStore.isTaskType(TaskType.DowngradeSubscription)"
      />
      <InfoFailedPayment
        v-if="tasksKanbanStore.isTaskType(TaskType.FailedPayment)"
      />
      <InfoRefundSubscription
        v-if="tasksKanbanStore.isTaskType(TaskType.RefundSubscription)"
      />
      <InfoAutoCanceledSubscription
        v-if="tasksKanbanStore.isTaskType(TaskType.AutoCanceledSubscription)"
      />
      <InfoUpgradeSubscription
        v-if="tasksKanbanStore.isTaskType(TaskType.UpgradeSubscription)"
      />
      <InfoHealthCheck
        v-if="tasksKanbanStore.isTaskType(TaskType.HealthCheck)"
      />
      <InfoSuccessBadFeedback
        v-if="tasksKanbanStore.isTaskType(TaskType.SuccessBadFeedback)"
      />
      <InfoCallbackRequest
        v-if="tasksKanbanStore.isTaskType(TaskType.CallbackRequest)"
      />
      <InfoChangeSchedule
        v-if="tasksKanbanStore.isTaskType(TaskType.ChangeSchedule)"
      />
      <InfoChangeTutor
        v-if="tasksKanbanStore.isTaskType(TaskType.ChangeTutor)"
      />
      <InfoCustomerRequest
        v-if="tasksKanbanStore.isTaskType(TaskType.CustomRequest)"
      />
      <InfoFirstLessonCancellation
        v-if="tasksKanbanStore.isTaskType(TaskType.FirstLessonCancellation)"
      />
      <InfoFirstLessonCancellationTutor
        v-if="tasksKanbanStore.isTaskType(TaskType.FirstLessonCancellationTutor)"
      />
      <InfoInvoiceCreation
        v-if="tasksKanbanStore.isTaskType(TaskType.InvoiceCreation)"
      />
      <InfoManualActivation
        v-if="tasksKanbanStore.isTaskType(TaskType.ManualActivation)"
      />
      <InfoPauseSubscription
        v-if="tasksKanbanStore.isTaskType(TaskType.PauseSubscription)"
      />
      <InfoResumeSubscription
        v-if="tasksKanbanStore.isTaskType(TaskType.ResumeSubscription)"
      />
      <InfoSubstituteTutor
        v-if="tasksKanbanStore.isTaskType(TaskType.SubstituteTutor)"
      />
      <InfoSupportBadFeedback
        v-if="tasksKanbanStore.isTaskType(TaskType.SupportBadFeedback)"
      />
      <InfoTechnicalIssue
        v-if="tasksKanbanStore.isTaskType(TaskType.TechnicalIssue)"
      />
    </template>
    <TaskAdditionalDetailsPlaceholder
      v-else
    />
  </div>
</template>

<style lang="scss" scoped src="./TaskAdditionalDetails.scss" />
